// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rotate-device-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: radial-gradient(ellipse at 50% 30%, rgba(37, 112, 174, 0.35) 0%, transparent 55%), linear-gradient(180deg, #0a1028 0%, #040d20 100%);
  color: #fff;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.rotate-device-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 20rem;
}

.rotate-device-overlay__phone {
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.rotate-device-overlay__phone-body {
  width: 2.25rem;
  height: 3.75rem;
  border: 2.5px solid #81cdf6;
  border-radius: 0.45rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 24px rgba(101, 188, 231, 0.35);
  animation: rotate-device-phone 1.8s ease-in-out infinite;
  transform-origin: center center;
}

.rotate-device-overlay__phone-screen {
  width: 1.5rem;
  height: 2.75rem;
  border-radius: 0.2rem;
  background: linear-gradient(180deg, rgba(101, 188, 231, 0.45) 0%, rgba(37, 112, 174, 0.25) 100%);
}

.rotate-device-overlay__arrow {
  position: absolute;
  right: 0.15rem;
  bottom: 0.35rem;
  width: 1.75rem;
  height: 1.75rem;
  color: #65bce7;
  opacity: 0.9;
  animation: rotate-device-arrow-pulse 1.8s ease-in-out infinite;
}

.rotate-device-overlay__title {
  margin: 0;
  font-family: "Bebas Neue", Impact, sans-serif;
  font-size: 1.75rem;
  letter-spacing: 0.04em;
  line-height: 1.15;
  color: #fff;
}

.rotate-device-overlay__subtitle {
  margin: 0;
  font-family: "Nunito Sans", system-ui, sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.72);
}

@keyframes rotate-device-phone {
  0%, 20% {
    transform: rotate(0deg);
  }
  45%, 70% {
    transform: rotate(90deg);
  }
  90%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes rotate-device-arrow-pulse {
  0%, 100% {
    opacity: 0.45;
    transform: scale(0.95);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/RotateDeviceOverlay/RotateDeviceOverlay.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gJACE;EAEF,WAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,wDAAA;EACA,+BAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,gGAAA;AADF;;AAIA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,8DAAA;AADF;;AAIA;EACE,SAAA;EACA,6CAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;AADF;;AAIA;EACE,SAAA;EACA,iDAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AADF;;AAIA;EACE;IAEE,uBAAA;EAFF;EAIA;IAEE,wBAAA;EAHF;EAKA;IAEE,uBAAA;EAJF;AACF;AAOA;EACE;IAEE,aAAA;IACA,sBAAA;EANF;EAQA;IACE,UAAA;IACA,sBAAA;EANF;AACF","sourcesContent":[".rotate-device-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background:\n    radial-gradient(ellipse at 50% 30%, rgba(37, 112, 174, 0.35) 0%, transparent 55%),\n    linear-gradient(180deg, #0a1028 0%, #040d20 100%);\n  color: #fff;\n  text-align: center;\n  user-select: none;\n  touch-action: none;\n}\n\n.rotate-device-overlay__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  max-width: 20rem;\n}\n\n.rotate-device-overlay__phone {\n  position: relative;\n  width: 5.5rem;\n  height: 5.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.5rem;\n}\n\n.rotate-device-overlay__phone-body {\n  width: 2.25rem;\n  height: 3.75rem;\n  border: 2.5px solid #81cdf6;\n  border-radius: 0.45rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 24px rgba(101, 188, 231, 0.35);\n  animation: rotate-device-phone 1.8s ease-in-out infinite;\n  transform-origin: center center;\n}\n\n.rotate-device-overlay__phone-screen {\n  width: 1.5rem;\n  height: 2.75rem;\n  border-radius: 0.2rem;\n  background: linear-gradient(180deg, rgba(101, 188, 231, 0.45) 0%, rgba(37, 112, 174, 0.25) 100%);\n}\n\n.rotate-device-overlay__arrow {\n  position: absolute;\n  right: 0.15rem;\n  bottom: 0.35rem;\n  width: 1.75rem;\n  height: 1.75rem;\n  color: #65bce7;\n  opacity: 0.9;\n  animation: rotate-device-arrow-pulse 1.8s ease-in-out infinite;\n}\n\n.rotate-device-overlay__title {\n  margin: 0;\n  font-family: 'Bebas Neue', Impact, sans-serif;\n  font-size: 1.75rem;\n  letter-spacing: 0.04em;\n  line-height: 1.15;\n  color: #fff;\n}\n\n.rotate-device-overlay__subtitle {\n  margin: 0;\n  font-family: 'Nunito Sans', system-ui, sans-serif;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n@keyframes rotate-device-phone {\n  0%,\n  20% {\n    transform: rotate(0deg);\n  }\n  45%,\n  70% {\n    transform: rotate(90deg);\n  }\n  90%,\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@keyframes rotate-device-arrow-pulse {\n  0%,\n  100% {\n    opacity: 0.45;\n    transform: scale(0.95);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
